import {
	ToastContainer as ToastifyContainer,
	cssTransition,
} from 'react-toastify'
import styled, { keyframes } from 'styled-components'

const animationDuration = '0.8s'

const slideInAnimation = keyframes`
	0% { transform: translateY(1000px); opacity: 0; }
	100% { transform: translateY(0); opacity: 1; }
`

const slideOutAnimation = keyframes`
	0% { transform: translateY(0); opacity: 1; }
	100% { transform: translateY(1000px); opacity: 0; }
`

const progressBarAnimation = keyframes`
0% { transform: scaleX(1); }
100% { transform: scaleX(0); }
`

export const SlideAnimation = cssTransition({
	enter: 'slide-in',
	exit: 'slide-out',
})

export const ToastContainer = styled(ToastifyContainer)`
	&&&.Toastify__toast-container {
		z-index: ${(props) => props.theme.zIndexes.toast};
		position: fixed;
		padding: 1rem;
		width: 100%;
		bottom: 0rem;
		right: 0rem;
		display: flex;
		justify-content: center;
		bottom: 9rem;

		${(props) => props.theme.deviceBreakpoints.tablet} {
			right: 2rem;
			bottom: 0rem;
			width: 22.5rem;
			display: block;
		}

		${(props) => props.theme.deviceBreakpoints.desktop} {
			bottom: 4.5rem;
		}
	}

	.slide-in {
		animation: ${slideInAnimation} ${animationDuration}
			cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
	}
	.slide-out {
		animation: ${slideOutAnimation} ${animationDuration}
			cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
	}

	.Toastify__progress-bar {
		animation: ${progressBarAnimation} linear 1 forwards;
	}
`
